<template>
  <v-carousel v-model="model" cycle hide-delimiters :show-arrows="false" :height="mobile ? '240' : $vuetify.breakpoint.md ? '150': '100'" >
    <v-carousel-item v-for="(item, i) in bunner" :key="i">
      <v-sheet :color="item.color" height="100%" tile>
        <v-row class="fill-height align-center justify-center px-10">
          <v-col :style="'line-height: 1.1'" :class="mobile ? 'col-12 text-h6 align-center mt-auto' : 'col-8 text-end text-h5 pl-10'" class="text-center font-weight-bold justify-end"  >{{ item.text }}</v-col>
          <v-col :class="mobile ? 'col-12 text-center mb-auto' : 'col-8 justify-start'" class="col-md-4 col-lg-3"><v-btn rounded outlined :href="item.link" target="_blank">Saiba mais</v-btn></v-col>
        </v-row>
      <!-- <v-sheet :color="item.color" height="100%" class="d-flex align-center px-12 justify-center">
          <div class="text-h5 font-weight-bold text-center">{{ item.text }}</div>
      </v-sheet> -->
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data: () => ({
    model: 0,
    colors: ["primary", "secondary", "yellow darken-2", "red", "orange"],
    bunner: [
      {text: "Quer otimizar as Análises de Caixa das Declarações de Imposto de Renda do seu Escritório de Contabilidade?", color: "blue darken-2", link: "https://malhafina.cnt.br/#/"},
      {text: "Controle de Caixa, Gestão de Documentos e Acompanhamento do processamentos das declarações. Você precisa disso em um só lugar?", color: "#008390", link: "https://tesys.com.br/"},
      {text: "Esqueça papéis e solicite Consentimentos, seguindo às exigências da LGPD, de forma online.", color: "#379c6f", link: "https://econsenso.com.br/"},
      ]
  }),
  computed:{
    mobile(){
      if (this.$vuetify.breakpoint.smAndDown) return true;
      return false;
    }
  }
};
</script>